module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "info-logo"
  }, [_c('img', {
    attrs: {
      "src": require("assets/image/information.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dot",
    class: {
      active: _vm.task_list.length != 0 || _vm.exam_list.length != 0
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fixed-box"
  }, [_c('div', {
    staticClass: "fixed-main"
  }, [_c('div', {
    staticClass: "tab-head"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task_flag),
      expression: "task_flag"
    }],
    class: {
      active: _vm.activeIndex == 0
    },
    on: {
      "click": function($event) {
        _vm.changeIndex(0)
      }
    }
  }, [_vm._v("任务消息")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exam_flag),
      expression: "exam_flag"
    }],
    class: {
      active: _vm.activeIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.changeIndex(1)
      }
    }
  }, [_vm._v("审核消息")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-wrap"
  }, [_c('z-scrollDiv', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task_flag && _vm.activeIndex == 0),
      expression: "task_flag && activeIndex == 0"
    }],
    class: {
      active: _vm.task_list.length !== 0
    }
  }, _vm._l((_vm.task_list), function(item, index) {
    return _c('div', {
      key: item.info_id,
      staticClass: "info-item"
    }, [_c('div', {
      staticClass: "message-box"
    }, [_c('div', {
      staticClass: "main"
    }, [_vm._v("\n                                " + _vm._s(item.message) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "confirm-btn",
      on: {
        "click": function($event) {
          _vm.readInfo(item.info_id, index)
        }
      }
    }, [_vm._v("知道了")])])
  })), _vm._v(" "), _c('z-scrollDiv', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exam_flag && _vm.activeIndex == 1),
      expression: "exam_flag && activeIndex == 1"
    }],
    class: {
      active: _vm.exam_list.length !== 0
    }
  }, _vm._l((_vm.exam_list), function(item, index) {
    return _c('div', {
      key: item.info_id,
      staticClass: "info-item"
    }, [_c('div', {
      staticClass: "message-box"
    }, [_c('div', {
      staticClass: "main"
    }, [_vm._v("\n                                " + _vm._s(item.message) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "confirm-btn",
      on: {
        "click": function($event) {
          _vm.readInfo(item.info_id, index)
        }
      }
    }, [_vm._v("知道了")])])
  }))], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "front-btn green",
    on: {
      "click": _vm.link
    }
  }, [_vm._v("查看全部")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": require("assets/image/info-nothing.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-113cc769!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/info/read-info.vue
// module id = 691
// module chunks = 1